/** Stamped into .vif backups and the settings footer. */
export const APP_VERSION = '0.1.0-beta';
